<template>
  <!-- O item de um relacionamento de cardinalidade 1 numa linha própria, ANTES dos campos dele.

       Não no subtítulo, que é lugar de informação menos rebuscada — ali o nome do item competia com o
       da coleção na mesma fonte apagada, e o identificador é o assunto da seção, não uma nota de
       rodapé dela.

       Aqui ele ganha a largura inteira, a cor de leitura e a régua da instância à esquerda — a mesma
       linha que a seção-tabela dá a cada item dela. Uma seção de um item e uma de vários passam a
       dizer a mesma coisa da mesma forma. -->
  <!-- No recuo dos campos (`ontos-inset`): a régua e o nome começam onde eles começam -->
  <div class="related-item-line ontos-inset">
    <ontos-color-accent vertical class="related-item-line-accent" :color="instanceColorOf(item)"/>
    <ontos-property-value class="text-body-1" :property="property" :value="item" :context="context"
                          variant="detail" :accent="false" @link="$emit('link', $event)"/>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import IdeaProperty from '@/types/IdeaProperty'
import {InstanceContext} from '@/types/InstanceContext'
import ColorAccent from '@/components/shared/ColorAccent.vue'
import PropertyValue from '@/components/live/instance/PropertyValue.vue'
import {instanceColorOf} from '@/utils/propertyDisplay'

/**
 * A linha do item relacionado na ficha, no alto da aba de um relacionamento simples, antes dos
 * campos dele e na margem deles (decisão do usuário).
 */
@Component({
  name: 'ontos-related-item-line',
  emits: ['link'],
  components: {'ontos-color-accent': ColorAccent, 'ontos-property-value': PropertyValue}
})
class RelatedItemLine extends Vue {
  /** O relacionamento que levou ao item. */
  @Prop({type: Object, required: true}) readonly property!: IdeaProperty
  /** O item, como o relacionamento o traz: com _instance e _identifier. */
  @Prop({type: Object, required: true}) readonly item!: any
  @Prop({type: Object, required: true}) readonly context!: InstanceContext

  //exposta ao template: função de módulo não é enxergada de lá
  instanceColorOf = instanceColorOf
}

export default toNative(RelatedItemLine)
</script>

<style scoped>
/* O `stretch` é o que dá altura à régua */
.related-item-line {
  display: flex;
  align-items: stretch;
  margin-bottom: 12px;
}

.related-item-line-accent {
  margin-right: 8px;
}
</style>
